import React from "react";

import { SignUpService } from "./services/SignUpService";
import { SignUpView } from "./views/SignUpView";
import dependencyInjection from "../../../common/util/dependencyInjection";
import RedirectIfAuthenticated from "../shared/components/RedirectIfAuthenticated";
import { SignInService } from "../SignIn/services/SignInService";

interface Services {
  signUpService: SignUpService;
  signInService: SignInService;
}

const signUpService = new SignUpService();
const signInService = new SignInService();

const [SignUpDependencyProvider, useSignUpDeps] = dependencyInjection<Services>({
  services: { signUpService, signInService },
});

const SignUpPage = () => (
  <RedirectIfAuthenticated>
    <SignUpDependencyProvider>
      <SignUpView />
    </SignUpDependencyProvider>
  </RedirectIfAuthenticated>
);

export { useSignUpDeps, SignUpPage };
